<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯发布国内首份金融AI白皮书，聚焦金融行业数字化升级</div>
      <div class="news-date">2022年9月3日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          <span class="mark-text">9月3日，2022世界人工智能大会腾讯论坛上，腾讯发布国内首份金融AI白皮书——《价值共生·2022金融AI发展研究报告》</span>
          以下简称“报告”）。报告由北京金融科技产业联盟作为指导单位，
          <span class="mark-text">由腾讯研究院与腾讯优图实验室、腾讯云、交通银行组成的联合课题组，联动腾讯内部及金融机构业务侧，</span>
          对国内多个金融机构进行了近五个月的调研，并将调研成果与课题组对金融AI的发展趋势思考进行汇总，共同编制而成。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news23.jpeg"/>
            <span>发布《价值共生·2022金融AI发展研究报告》启动仪式</span>
          </div>
        </div>
        <p>报告分为三大章节，从政策、行业、趋势三个层面出发，详细阐述了金融AI的发展环境与机遇、典型场景与案例、发展趋势与展望，全景呈现在数实融合加速的时代背景下，金融与AI深度融合创新所产生的积极影响和趋势洞察。</p>
        <p>人工智能作为一种“新基建”，正在与实体经济深度融合，推动社会及各个产业的数字化转型、智能升级和融合创新。报告指出，近年来，人工智能技术正不断发展，并与金融业务深度融合，衍生出新业态、新场景，深刻影响金融业的发展模式，同时也为金融服务夯实“安全底座”。</p>
        <p>
          <span class="mark-text">在政策层面，政策引导金融与AI融合发展，金融AI迎来新阶段。</span>
          报告从国际政策、国内政策、行业政策三个方面，介绍了金融AI发展的环境和机遇。近年来，从国际到国内，从社会整体到金融行业，政策层面不断出台战略规划，积极推动人工智能与金融的融合，深化AI的金融应用。报告指出，从政策趋势上看，金融AI发展前景广阔。随着全社会数字化的推进，金融机构与供应链、产业链上下游数据的贯通，以及跨界合作的推进，人工智能将为金融机构的业务提供更多方面、更好效果的助力作用，赋能金融机构降本增效、提升服务体验。
        </p>
        <p>
          <span class="mark-text">在行业层面，AI赋能智能金融场景创新，金融服务能力不断提升。</span>
          在AI与金融的加速融合下，催生出了智能营销、智能识别、智能理财、智能风控、智能客服等多种提升金融价值的场景。报告通过这五个场景和五个案例，展示了金融AI在我国目前发展现状。以交通银行融合了计算机视觉、机器学习、人工智能等新技术的“统一图像识别平台”为例，腾讯优图通过引入多模态技术提高信息抽取的泛化性能，助力解决非标准文档的OCR信息结构化提取，提高图像、单据识别率，推动业务效率以及用户体验提升。同时，该平台在信息录入等方面时长降低98.4%，且准确率高，能够大量节约人力成本。
        </p>
        <p>
          <span class="mark-text">在趋势层面，金融AI创新前景广阔，行业持续向好发展。</span>
          在金融机构数字化转型持续加速的背景下，报告的趋势篇从技术的深度、场景的广度、服务的可信度三方面，展望了金融AI未来发展的趋势。首先，从技术方面来看，以语音识别技术、视觉技术、全真互联技术为代表的技术不断发展成熟，将催生更多新业态，驱动行业创新发展。其次，从场景方面来看，在技术的深度不断加强的基础下，场景覆盖的广度也将不断向外拓展，实现全流程的数智化。最后，在安全保障方面，零信任架构、隐私计算技术的持续升级，将夯实金融机构在数据融通领域的可信基础。
        </p>
        <p>
          <span class="mark-text">在报告发布现场，腾讯云副总裁、腾讯优图实验室总经理吴运声表示：</span>
          “人工智能和机器学习已经成为金融行业可持续发展和增长的关键。随着人工智能技术的不断发展，在金融行业，人工智能的应用经历了标准能力应用探索、细分业务领域垂直深化阶段后，已进入全面应用和持续创新的新阶段，人工智能将用于更广更多元化的产品形态和功能。我们相信，人工智能+金融的探索仍有广阔空间，我们愿与业界携手共创，共赢数智未来。”
        </p>
        <p>
          <span class="mark-text">腾讯云副总裁郭仁声表示，这份报告呈现在数实融合加速的时代背景下，金融与AI深度融合创新所产生的积极影响和趋势洞察。</span>
        </p>
        <p>人工智能是金融科技的重要组成部分，也是金融机构数字化转型的重要技术支撑。不仅通过降本增效提升了银行价值，通过“千人千面”的7*24小时服务提升了客户服务水平，更通过解决信息不对称问题，着力解决小微企业信贷难题、切实服务实体经济，提升了社会价值。</p>
        <p>
          <span class="mark-text">腾讯研究院副院长杜晓宇在发布现场做了《金融AI:人工智能浪潮下的金融变革》的分享，</span>
          他表示，人工智能是金融科技的重要组成部分，也是金融机构数字化转型的重要技术支撑。通过与金融业务的深度融合创新，人工智能赋能金融业务实现多方面的价值提升。不仅通过降本增效提升了银行价值，通过“千人千面”的7*24小时服务提升了客户价值，更通过解决信息不对称问题，着力解决小微企业信贷难题、切实服务实体经济，提升了社会价值。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news23_1.png"/>
            <span>腾讯研究院副院长 杜晓宇</span>
          </div>
        </div>
        <p>
          <span class="mark-text">腾讯研究院副秘书长杨望在发布会现场对《价值共生·2022金融AI发展研究报告》进行了深度解读，</span>
          他认为，近年来，在政策推动和行业创新的共同驱动下，我国人工智能技术不断发展，并与金融业务深度融合，衍生出了很多新业态、新场景，深刻地推动了金融高质量发展。智能风控、智能客服、智能营销等场景的应用落地，极大地提升了金融机构的服务效率和用户体验。未来，随着金融机构、科技企业的持续深入创新合作，金融AI的应用场景将不断扩展、深化，助力数实融合，推动金融科技朝着可信、智能、安全、普惠的方向迈进。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news23_2.jpeg"/>
            <span>腾讯研究院副秘书长 杨望</span>
          </div>
        </div>
        <p>当下，金融AI已经迈入高质量发展阶段，科技公司、金融机构也在不断探索人工智能在金融领域的场景创新，更好地助力数实共生。</p>
        <p>
          目前，
          <span class="mark-text">腾讯云AI已经在金融场景广泛落地，与多家银行、保险、证券机构达成合作。</span>
          未来，腾讯云AI将持续做好金融业的“数字化助手”，以领先的自研技术能力、平台化产品、触达亿万用户的连接能力，与合作伙伴一起共建开放、健康、可持续的数字生态，实现与金融机构的价值共生。
        </p>
        <p>
          <a href="https://docs.qq.com/pdf/DVHFFcWRRa3dBSlhJ?&u=666658798e154bbdb493ad739377849a" target="_blank" class="mark-text" style="text-decoration: none">查看腾讯国内首份金融AI白皮书——《价值共生·2022金融AI发展研究报告》</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News23',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News23.vue